var _style, _g, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPayments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#050505;}\n\t.st1{opacity:0.5;fill:#050505;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.5,3.5H4.5C2.6,3.5,1,5.1,1,7v10c0,1.9,1.6,3.5,3.5,3.5h14.9c1.9,0,3.5-1.6,3.5-3.5V7 C23,5.1,21.4,3.5,19.5,3.5z M3,7c0-0.8,0.7-1.5,1.5-1.5h14.9C20.3,5.5,21,6.2,21,7v1H3V7z M21,17c0,0.8-0.7,1.5-1.5,1.5H4.5 C3.7,18.5,3,17.8,3,17v-6H21V17z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 18.1,
    cy: 14.6,
    r: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPayments);
export default __webpack_public_path__ + "static/media/icon-payments.3cc6591ca2853e8c4d1fda168e8ca1d0.svg";
export { ForwardRef as ReactComponent };